function formatDate(dateString) {
  const options = {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit',
    hour12: false
  };
  dateString &&
    new Intl.DateTimeFormat('pt-BR', options)
      .format(new Date(dateString))
      .replace(',', '');
}

export default formatDate
